import * as types from "../action/ActionType";
import { teamDetails, TeamDetails } from "../store/IntialStore";

interface TeamAction {
  type: string;
  payload: string;
}

export default function TeamReducer(
  state: TeamDetails = teamDetails,
  action: TeamAction
): TeamDetails {
  const { type, payload } = action;
  switch (type) {
    case types.UPDATE_COMPANY_LOGO:
      return { ...teamDetails, companyLogo: payload };
    default:
      return state;
  }
}
